import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS, TYPOGRAPHY } from '../../../../constants/interaxColors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'

export interface SprintCompletionBadgeProps {
  completionPercentage: number
  className?: string
}

/**
 * SprintCompletionBadge - Displays completion percentage in a styled badge
 * Shows percentage and "complete" label
 */
export const SprintCompletionBadge: React.FC<SprintCompletionBadgeProps> = ({
  completionPercentage,
  className = ''
}) => {
  const { t } = useTranslation()

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        paddingX: 1.5,
        paddingY: 0.5,
        backgroundColor: INTERAX_COLORS.sun20,
        borderRadius: '20px'
      }}
    >
      <Box
        component="span"
        sx={{
          ...TYPOGRAPHY.body3,
          fontWeight: 600,
          color: INTERAX_COLORS.sun
        }}
      >
        {completionPercentage}%
      </Box>
      <Box
        component="span"
        sx={{
          ...TYPOGRAPHY.body3,
          color: INTERAX_COLORS.sun
        }}
      >
        {t('gamer.sprintProgress.completed', 'complete')}
      </Box>
    </Box>
  )
}
